const CookieConsentBanner = () => {
  console.warn('The block canalplus.block.cookie_trckingtool is deprecated');
  return null;
};

export default CookieConsentBanner;
